
import { Location } from "../../domain";
export class PlanJobsLocationsListResponse {
    unassignedLocationsCount!: number;
    planAndJobsLocations?: Location[];
  }